/* tslint:disable */
/* eslint-disable */
/**
 * TOM YARD SERVICE API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Configuration } from '../configuration'
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios'
import globalAxios from 'axios'
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
  replaceWithSerializableTypeIfNeeded,
} from '../common'
// @ts-ignore
import {
  BASE_PATH,
  COLLECTION_FORMATS,
  type RequestArgs,
  BaseAPI,
  RequiredError,
  operationServerMap,
} from '../base'
// @ts-ignore
import type { CreateRailTrackRequest } from '../model'
// @ts-ignore
import type { CreateRailTrackResponse } from '../model'
// @ts-ignore
import type { DeleteRailTrackRequest } from '../model'
// @ts-ignore
import type { GetRailTracksResponse } from '../model'
// @ts-ignore
import type { UpdateRailTrackRequest } from '../model'
/**
 * RailTracksApi - axios parameter creator
 */
export const RailTracksApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {CreateRailTrackRequest} [createRailTrackRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createRailTrack: async (
      createRailTrackRequest?: CreateRailTrackRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/yard/api/RailTracks`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'
      localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        createRailTrackRequest,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {DeleteRailTrackRequest} [deleteRailTrackRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteRailTrack: async (
      deleteRailTrackRequest?: DeleteRailTrackRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/yard/api/RailTracks`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        deleteRailTrackRequest,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getRailTracks: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/yard/api/RailTracks`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {UpdateRailTrackRequest} [updateRailTrackRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateRailTrack: async (
      updateRailTrackRequest?: UpdateRailTrackRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/yard/api/RailTracks`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        updateRailTrackRequest,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * RailTracksApi - functional programming interface
 */
export const RailTracksApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = RailTracksApiAxiosParamCreator(configuration)
  return {
    /**
     *
     * @param {CreateRailTrackRequest} [createRailTrackRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async createRailTrack(
      createRailTrackRequest?: CreateRailTrackRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateRailTrackResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.createRailTrack(
        createRailTrackRequest,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['RailTracksApi.createRailTrack']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {DeleteRailTrackRequest} [deleteRailTrackRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async deleteRailTrack(
      deleteRailTrackRequest?: DeleteRailTrackRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.deleteRailTrack(
        deleteRailTrackRequest,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['RailTracksApi.deleteRailTrack']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getRailTracks(
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetRailTracksResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getRailTracks(options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['RailTracksApi.getRailTracks']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {UpdateRailTrackRequest} [updateRailTrackRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateRailTrack(
      updateRailTrackRequest?: UpdateRailTrackRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.updateRailTrack(
        updateRailTrackRequest,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['RailTracksApi.updateRailTrack']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
  }
}

/**
 * RailTracksApi - factory interface
 */
export const RailTracksApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = RailTracksApiFp(configuration)
  return {
    /**
     *
     * @param {CreateRailTrackRequest} [createRailTrackRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createRailTrack(
      createRailTrackRequest?: CreateRailTrackRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<CreateRailTrackResponse> {
      return localVarFp
        .createRailTrack(createRailTrackRequest, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @param {DeleteRailTrackRequest} [deleteRailTrackRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteRailTrack(
      deleteRailTrackRequest?: DeleteRailTrackRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .deleteRailTrack(deleteRailTrackRequest, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getRailTracks(options?: RawAxiosRequestConfig): AxiosPromise<GetRailTracksResponse> {
      return localVarFp.getRailTracks(options).then(request => request(axios, basePath))
    },
    /**
     *
     * @param {UpdateRailTrackRequest} [updateRailTrackRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateRailTrack(
      updateRailTrackRequest?: UpdateRailTrackRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .updateRailTrack(updateRailTrackRequest, options)
        .then(request => request(axios, basePath))
    },
  }
}

/**
 * RailTracksApi - object-oriented interface
 */
export class RailTracksApi extends BaseAPI {
  /**
   *
   * @param {CreateRailTrackRequest} [createRailTrackRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public createRailTrack(
    createRailTrackRequest?: CreateRailTrackRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return RailTracksApiFp(this.configuration)
      .createRailTrack(createRailTrackRequest, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {DeleteRailTrackRequest} [deleteRailTrackRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public deleteRailTrack(
    deleteRailTrackRequest?: DeleteRailTrackRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return RailTracksApiFp(this.configuration)
      .deleteRailTrack(deleteRailTrackRequest, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public getRailTracks(options?: RawAxiosRequestConfig) {
    return RailTracksApiFp(this.configuration)
      .getRailTracks(options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {UpdateRailTrackRequest} [updateRailTrackRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public updateRailTrack(
    updateRailTrackRequest?: UpdateRailTrackRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return RailTracksApiFp(this.configuration)
      .updateRailTrack(updateRailTrackRequest, options)
      .then(request => request(this.axios, this.basePath))
  }
}
